export { NewsListCTA } from './NewsListCTA'
export type { NewsListCTAProps } from './types'
